import CommonUtils from '@/resources/utils/common-utils'
import API from '@/config/api'
import Common from "./common";

const commonApi = {
    state: {
        upLeaveTab:''
    },
    mutations: {
        changeUpLeaveTab(state,value) {
            this.state.upLeaveTab = value
          },
        appletBannerList(state, data) {
            data.url = API.startClassApplet.bannerList
            CommonUtils.GetRequest(data)
        },
        appletAddBanner(state, data) {
            data.url = API.startClassApplet.addBanner
            CommonUtils.PostRequest(data)
        },
        appletEditBanner(state, data) {
            data.url = API.startClassApplet.editBanner
            CommonUtils.PostRequest(data)
        },
        appletUpOrDownBanner(state,data) {
            data.url = API.startClassApplet.upOrDownBanner
            CommonUtils.PostRequest(data)
        },
        appletAddFirstCategory(state, data) {
            data.url = API.startClassApplet.addFirstCategory
            CommonUtils.PostRequest(data)
        },
        appletFirstCategoryList(state, data) {
            data.url = API.startClassApplet.firstCategoryList
            CommonUtils.GetRequest(data)
        },
        appletEditFirstCategory(state, data) {
            data.url = API.startClassApplet.editFirstCategory
            CommonUtils.PostRequest(data)
        },
        appletSecondCategoryList(state, data) {
            data.url = API.startClassApplet.secondCategoryList
            CommonUtils.GetRequest(data)
        },
        appletAddSecondCategory(state, data) {
            data.url = API.startClassApplet.addSecondCategory
            CommonUtils.PostRequest(data)
        },
        appletEditSecondCategory(state, data) {
            data.url = API.startClassApplet.editSecondCategory
            CommonUtils.PostRequest(data)
        },
        appletGetWholeEnableList(state, data) {
            data.url = API.startClassApplet.getWholeEnableList
            CommonUtils.GetRequest(data)
        },
        appletGetListByCategory(state, data) {
            data.url = API.startClassApplet.getListByCategory
            CommonUtils.GetRequest(data)
        },
        appletGetCourseDetail(state, data) {
            data.url = API.startClassApplet.getCourseDetail
            CommonUtils.GetRequest(data)
        },
        appletAddCourse(state, data) {
            data.url = API.startClassApplet.addCourse
            CommonUtils.PostRequest(data)
        },
        appletEditCourse(state, data) {
            data.url = API.startClassApplet.editCourse
            CommonUtils.PostRequest(data)
        },
        appletDeleteCourse(state, data) {
            data.url = API.startClassApplet.deleteCourse
            CommonUtils.PostRequest(data)
        },
        appletUpOrDownCourse(state, data) {
            data.url = API.startClassApplet.upOrDownCourse
            CommonUtils.PostRequest(data)
        },
        appletBatchUpOrDownCourse(state, data) {
            data.url = API.startClassApplet.batchUpOrDownCourse
            CommonUtils.PostRequest(data)
        },
        appletRecommendCourse(state, data) {
            data.url = API.startClassApplet.recommendCourse
            CommonUtils.PostRequest(data)
        },
        appletQuestionList(state, data) {
            data.url = API.startClassApplet.questionList
            CommonUtils.GetRequest(data)
        },
        appletQuestionDetail(state, data) {
            data.url = API.startClassApplet.questionDetail
            CommonUtils.GetRequest(data)
        },
        appletQuestionStatistics(state, data) {
            data.url = API.startClassApplet.questionStatistics
            CommonUtils.GetRequest(data)
        },
        appletGetRecommendList(state, data) {
            data.url = API.startClassApplet.getRecommendList
            CommonUtils.GetRequest(data)
        },
        appletSetRecommendSort(state, data) {
            data.url = API.startClassApplet.setRecommendSort
            CommonUtils.PostRequest(data)
        },
        appletAnswerRecord(state, data) {
            data.url = API.startClassApplet.answerRecord
            CommonUtils.GetRequest(data)
        },
        appletAnswerDetail(state, data) {
            data.url = API.startClassApplet.answerDetail
            CommonUtils.GetRequest(data)
        },
        appletInternalUserList(state, data) {
            data.url = API.startClassApplet.internalUserList
            CommonUtils.GetRequest(data)
        },
        appletGetInternalQrCode(state, data) {
            data.url = API.startClassApplet.getInternalQrCode
            CommonUtils.GetRequest(data)
        },
        appletGetCourseStatistics(state,data) {
            data.url = API.startClassApplet.getCourseStatistics
            CommonUtils.GetRequest(data)
        },
        appletGetCourseVideoStatistics(state,data) {
            data.url = API.startClassApplet.getCourseVideoStatistics
            CommonUtils.GetRequest(data)
        },
        appletGetCourseVideoStatisticsSum(state,data) {
            data.url = API.startClassApplet.getCourseVideoStatisticsSum
            CommonUtils.GetRequest(data)
        },
        appletGetCoursePlayLog(state,data) {
            data.url = API.startClassApplet.getCoursePlayLog
            CommonUtils.GetRequest(data)
        },
        appletGetCoursePlayStatistics(state,data) {
            data.url = API.startClassApplet.getCoursePlayStatistics
            CommonUtils.GetRequest(data)
        },
        appletGetCourseVideoPlayLog(state,data) {
            data.url = API.startClassApplet.getCourseVideoPlayLog
            CommonUtils.GetRequest(data)
        },
        appletGetCourseStatisticsSum(state,data) {
            data.url = API.startClassApplet.getCourseStatisticsSum
            CommonUtils.GetRequest(data)
        },
        appletGetCourseVideoPlayStatistics(state,data) {
            data.url = API.startClassApplet.getCourseVideoPlayStatistics
            CommonUtils.GetRequest(data)
        },
        appletBatchClassifyCourseResource(state,data) {
            data.url = API.startClassApplet.batchClassifyCourseResource
            CommonUtils.PostRequest(data)
        },
        appletGetCourseResourceList(state,data) {
            data.url = API.startClassApplet.getCourseResourceList
            CommonUtils.GetRequest(data)
        },
        appleClassifyCourseResource(state,data) {
            data.url = API.startClassApplet.classifyCourseResource
            CommonUtils.PostRequest(data)
        },
        getLimitDurationLog(state,data) {
            data.url = API.startClassApplet.getLimitDurationLog
            CommonUtils.GetRequest(data)
        },
        editCoverPicture(state,data) {
            data.url = API.startClassApplet.editCoverPicture
            CommonUtils.PostRequest(data)
        },
        secretSignalQueriedList(state,data) {
            data.url = API.startClassApplet.secretSignalQueriedList
            CommonUtils.GetRequest(data)
        },
        secretSignalQueriedDetails(state,data) {
            data.url = API.startClassApplet.secretSignalQueriedDetails
            CommonUtils.GetRequest(data)
        },
        secretSignalList(state,data) {
            data.url = API.startClassApplet.secretSignalList
            CommonUtils.GetRequest(data)
        },
        secretSignalChangeStatus(state,data) {
            data.url = API.startClassApplet.secretSignalChangeStatus
            CommonUtils.PostRequest(data)
        },
        secretSignalUploadLogList(state,data) {
            data.url = API.startClassApplet.secretSignalUploadLogList
            CommonUtils.GetRequest(data)
        },
        secretSignalUpload(state,data) {
            data.url = API.startClassApplet.secretSignalUpload
            CommonUtils.PostRequest(data)
        },
        getCouponsPageList(state,data) {
            data.url = API.startClassApplet.getCouponsPageList
            CommonUtils.GetRequest(data)
        },
        addCoupons(state,data) {
            data.url = API.startClassApplet.addCoupons
            CommonUtils.PostRequest(data)
        },
        editCoupons(state,data) {
            data.url = API.startClassApplet.editCoupons
            CommonUtils.PostRequest(data)
        },
        getCouponsDetails(state,data) {
            data.url = API.startClassApplet.getCouponsDetails
            CommonUtils.GetRequest(data)
        },
        createExchangeCode(state,data) {
            data.url = API.startClassApplet.createExchangeCode
            CommonUtils.PostRequest(data)
        },
        getExchangeList(state,data) {
            data.url = API.startClassApplet.getExchangeList
            CommonUtils.GetRequest(data)
        },
        exportExchangeCode(state,data) {
            data.url = API.startClassApplet.exportExchangeCode
            CommonUtils.GetRequest(data)
        },
        getWatchSettings(state,data) {
            data.url = API.startClassApplet.getWatchSettings
            CommonUtils.GetRequest(data)
        },
        saveWatchSettings(state,data) {
            data.url = API.startClassApplet.saveWatchSettings
            CommonUtils.PostRequest(data)
        },
        getExchangePageQrcode(state,data) {
            data.url = API.startClassApplet.getExchangePageQrcode
            CommonUtils.GetRequest(data)
        },
    },
}

export default commonApi



// WEBPACK FOOTER //
// ./src/store/modules/startClassApplet.js